import { withTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import UAEFDLOverview from './UAEFDLOverview';

const UAEFDLContainer = () => {
	return (
		<div>
			<Routes>
				<Route path="overview" element={<UAEFDLOverview />} />
			</Routes>
		</div>
	);
};

export default withTranslation()(UAEFDLContainer);
